import { defineComponent, computed, watch, onMounted, h } from '@vue/composition-api';
import { withInstall } from '../util/index.js';
import Overlay from '../overlay/index.js';
import useLazyRender from '../util/useLazyRender.js';

var Popup = defineComponent({
  name: 'm-popup',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      "default": false
    },
    zIndex: {
      type: [Number, String],
      "default": 100
    },
    mask: {
      type: Boolean,
      "default": true
    },
    duration: {
      type: [Number, String],
      "default": 300
    },
    maskClass: {
      type: String,
      "default": ''
    },
    position: {
      type: String,
      "default": ''
    },
    lockScroll: {
      type: Boolean,
      "default": false
    },
    maskClosable: {
      type: Boolean,
      "default": false
    }
  },
  slots: ['left'],
  emits: ['close', 'open', 'maskClick'],
  setup: function setup(props, context) {
    var lazyRender = useLazyRender(function () {
      return props.visible;
    });
    var validDirectionList = ['left', 'right', 'top', 'bottom'];
    var direction = computed(function () {
      return validDirectionList.includes(props.position) ? props.position : 'default';
    });

    var handleMaskClick = function handleMaskClick(event) {
      if (!props.maskClosable) return;
      context.emit('change', false);
      context.emit('maskClick');
    };

    watch(function () {
      return props.visible;
    }, function (newVlaue) {
      context.emit(newVlaue ? 'open' : 'close');
    });
    onMounted(function () {
      props.visible && context.emit('open');
    });
    return function () {
      return h("div", [h(Overlay, {
        "class": props.maskClass,
        "attrs": {
          "duration": props.duration,
          "visible": props.visible && props.mask,
          "zIndex": props.zIndex,
          "lockScroll": props.lockScroll
        },
        "nativeOn": {
          "click": handleMaskClick
        }
      }), h("transition", {
        "attrs": {
          "name": direction.value === 'default' ? 'm-ani-fade' : "m-ani-popup_".concat(direction.value),
          "appear": true
        }
      }, [lazyRender(function () {
        var _context$slots$defaul, _context$slots;

        return h("div", {
          "directives": [{
            name: "show",
            value: props.visible
          }],
          "class": ['m-popup', "m-popup_".concat(direction.value)],
          "style": {
            zIndex: +props.zIndex + 1,
            transitionDuration: "".concat(props.duration, "ms")
          }
        }, [(_context$slots$defaul = (_context$slots = context.slots)["default"]) === null || _context$slots$defaul === void 0 ? void 0 : _context$slots$defaul.call(_context$slots)]);
      })])]);
    };
  }
});
withInstall(Popup);

export { Popup as default };
//# sourceMappingURL=index.js.map
